<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Basic Form</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li>
          </ul>
        </div>
      </div>
    </div>
    <app-maser-page-header></app-maser-page-header>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Business Type</th>
          <th>Start Date</th>
          <th> Started By</th>
          <th> Product</th>
          <th> Old Mrp</th>
          <th> New Mrp</th>
          <th> old Discounted Price</th>
          <th> New Discounted Price</th>
          <th>End Date</th>
          <th> Ended By</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let trace of dataSource">
          <th>{{trace['business_type_name']}}</th>
          <td>{{trace['start_date'] | date:'medium'}}</td>
          <td>{{trace['start_by']}}</td>
          <td>{{trace['product_short_name']}}</td>
          <td>{{trace['old_mrp']}}</td>
          <td [style.color]=" trace.old_mrp != trace.new_mrp ?  'red' : 'black'">{{trace['new_mrp']}}</td>
          <td>{{trace['old_discounted_price']}}</td>
          <td [style.color]=" trace.old_discounted_price != trace.new_discounted_price ?  'red' : 'black'">
            {{trace['new_discounted_price']}}</td>
          <td *ngIf="trace['end_date'] != '-'">{{trace['end_date'] | date:'medium'}}</td>
          <td *ngIf="trace['end_date'] == '-'">{{trace['end_date']}}</td>
          <td>{{trace['ended_by']}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
